import { ReactElement, useState } from 'react';

import { Theme, Box, SxProps } from '@mui/material';
import { TailSpin } from 'react-loader-spinner';
import { pdfjs, Document, Page } from 'react-pdf';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

type PDFViewerProps = Readonly<{
  documentUrl: string;
  onError?: () => void;
  width?: number;
}>;

/** This component will render just the preview of the PDF - ie the first page. It can be expanded to have controls and be a full PDF viewer in the future if needed.  */
export const BackrsPDFPreview = ({
  documentUrl,
  onError,
  width = 800,
}: PDFViewerProps): ReactElement => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box onClick={() => window.open(documentUrl)} sx={containerStyle}>
      <Box sx={pdfContainerStyle}>
        <Document
          file={documentUrl}
          onLoadError={onError}
          loading="" // we are handling loading state ourselves
          options={options}
        >
          {isLoading && (
            <Box sx={loadingContainerStyle}>
              <TailSpin color="#000" height={50} width={50} />
            </Box>
          )}
          {/* we only want to show the first page - the user is then encouraged to click the PDF and view the whole thing */}
          <Page
            onRenderSuccess={() => setIsLoading(false)}
            loading=""
            pageNumber={1}
            width={width}
          />
        </Document>
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  mt: 3,
  cursor: 'pointer',
};

const pdfContainerStyle: SxProps<Theme> = {
  mt: 3,
  cursor: 'pointer',
  height: 400,
  overflow: 'hidden',
  flexDirection: 'column',
  alignItems: 'center',
  display: 'flex',
};

const loadingContainerStyle: SxProps<Theme> = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
